import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { InternalUser, Roles, Agency, Users } from '@adminmodel/admin';
import { environment } from '@environment/environment';
import { Station } from '../Model/agency';
import { GetEnvVarService } from "../../../service/get-env-var.service";

//import { AdminAgency } from '@agency/Model/agency';

@Injectable()
export class AgencyService {
  private baseUrl: string;
  AgencyID: any;
  Agencyname: String;
 // AdvertiserID : any;
 // Advertisername : String;
  StationID: any[];
  StationName: String;
  StationGroupName:String;

  // IPVersion: any;
  // BrowserType: any;
  // Search: any;

  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getUserservicebaseurl();
    
  }
    // Method to get Agency id for duplicate Details
 
   internalAgencySearch(agencyID: any): Observable<any> {
debugger;
    if (agencyID === '') { agencyID = 0; }
    return this.http.get(this.baseUrl + `/api/AgencySearch/` + <number>agencyID)
      .map(response => response as any)
      .catch(handleError);
  }

  internalAgencynameSearch(agencyname: any): Observable<any> {
    debugger;
        if (agencyname === '') { agencyname = 0; }
        return this.http.get(this.baseUrl + `/api/AgencynameSearch/` + <string>agencyname)
          .map(response => response as any)
          .catch(handleError);
      }

  internalstationnameSearch(stationName: any): Observable<any> {
        debugger;
            if (stationName === '') { stationName = 0; }
            return this.http.get(this.baseUrl + `/api/StationnameSearch/` + <string>stationName)
              .map(response => response as any)
              .catch(handleError);
          }

  internalStationSearch(stationID: any): Observable<any> {
    debugger;
    if (stationID === '') { stationID = 0; }
    return this.http.get(this.baseUrl + `/api/StationSearch/` + <number>stationID)
      .map(response => response as any)
      .catch(handleError);
  }

  // Method to add new Agency
  postNewAgencyDetails(AgencyID: any, Agencyname: any):  Observable<any[]> {
    debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
   //return this.http.post(this.baseUrl + `/api/Saveagency/`+ AgencyID, JSON.stringify(Agencyname), options)
    return this.http.post(this.baseUrl + `/api/Saveagency/`+ AgencyID + `/` + Agencyname, options)
      .map(response => response)
            .catch(handleError);
  }
  // Method to upload multiple external user details
  
  // Method to add new Station
   postNewStationDetails(StationID: any, StationName: any,StationGroupName: any ):  Observable<any[]> {
    debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
   //return this.http.post(this.baseUrl + `/api/Saveagency/`+ AgencyID, JSON.stringify(Agencyname), options)
    return this.http.post(this.baseUrl + `/api/Savestation/`+ StationID + `/` + StationName + `/` + StationGroupName, options)
      .map(response => response)
            .catch(handleError);
  }
  
  // Method to get the agency list
  getAgencyList() {
    debugger;
   // return this.http.get(this.baseUrl + `/api/Agency`)
   return this.http.get(this.baseUrl + `/api/AgencyList`)
      .map(response => response as Roles[])
      .catch(handleError);
  }
  getStationList() {
    debugger;
    return this.http.get(this.baseUrl + `/api/Station`)
      .map(response => response as Roles[])
      .catch(handleError);
  }


  //method to update Agency user details
  updateAgencyDetails(AgencyID: any, Agencyname: any): Observable<any> {
  debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/UpdateAgency/`+ AgencyID + `/` + Agencyname, options)
      .map(response => response as any);
  }
  
updatestationDetails(updatedStationDetails: any): Observable<any> {
  debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/UpdateStation/`+ updatedStationDetails.stationID, JSON.stringify(updatedStationDetails), options)
      .map(response => response as any);
  }

   
}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/admin/agency/Service/agency.service.ts